import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Experimental_CssVarsProvider as CssVarsProvider, experimental_extendTheme as extendTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './styles/brand-kit.css';

// Import pages and components
import Homepage from './components/Homepage';
import Pricing from './components/Pricing';
import Products from './components/Products';
import Services from './components/Services';
import Devices from './components/Devices';
import About from './components/About';
import Contact from './components/Contact';
import Support from './components/Support';
import McpInfo from './components/McpInfo';
import Privacy from './pages/Privacy';
import Tos from './pages/Tos';
import Beta from './pages/Beta';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 2,
    },
  },
});

const theme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: '#5FA463',
          light: '#81c784',
          dark: '#388e3c',
        },
        background: {
          default: '#FAFAF8',
          paper: '#ffffff',
        },
        text: {
          primary: '#2D2C2A',
          secondary: '#5A5856',
        },
      },
    },
  },
  typography: {
    fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <CssVarsProvider theme={theme} defaultMode="light" modeStorageKey="family_public_ui_mode">
          <CssBaseline />
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/products" element={<Products />} />
            <Route path="/services" element={<Services />} />
            <Route path="/devices" element={<Devices />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/support" element={<Support />} />
            <Route path="/mcp-info" element={<McpInfo />} />
            <Route path="/beta" element={<Beta />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/tos" element={<Tos />} />
          </Routes>
        </CssVarsProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;